import { Component, Input } from '@angular/core';

const CONFIG: Record<string, { label: string; cssClass: string }> = {
  CASH_IN:  { label: 'Collect', cssClass: 'bg-light-default' },
  CASH_OUT: { label: 'Payment', cssClass: 'bg-light-primary' },
};

@Component({
  selector: 'app-operation-type-badge',
  template: `
    <div class="badge badge-pill" [ngClass]="config.cssClass">
      {{ config.label }}
    </div>
  `
})
export class OperationTypeBadgeComponent {
  config = { label: '', cssClass: '' };

  @Input() set type(value: string) {
    this.config = CONFIG[value] ?? { label: value, cssClass: '' };
  }
}